import { CancelButton, AcceptButton } from "@/shared/form/button";
import { useTranslations } from "use-intl";
import { Result } from "@/shared/feedback/result";

export function Welcome({
  getChoice,
}: {
  getChoice: (choice: boolean) => void;
}) {
  const t = useTranslations("GlobalWizard");

  return (
    <div>
      <Result
        status="warning"
        title={t("WELCOME_MESSAGE")}
        extra={
          <div className={"flex justify-center gap-4"}>
            <CancelButton onClick={() => getChoice(false)} />
            <AcceptButton onClick={() => getChoice(true)} />
          </div>
        }
      />
    </div>
  );
}
